import React from 'react';
import { ShoppingBag, Calendar, MessageSquare, Star, DollarSign, Zap, AlertCircle, ArrowRight, Plus, Clock, CheckCircle2, TrendingUp, TrendingDown, ShieldAlert, Users, Eye, MousePointerClick, Heart, Activity, Video, FileText, Store, Settings, AlertTriangle, Play, XCircle, RefreshCw, Lightbulb, ArrowUpRight, Crown, ShieldCheck, Percent, CreditCard } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface OverviewTabProps {
  showToast: (msg: string) => void;
  setActiveTab: (tab: string) => void;
}
export function OverviewTab({
  showToast,
  setActiveTab
}: OverviewTabProps) {
  return <div className="space-y-4 sm:space-y-6 animate-in fade-in duration-300" data-id="element-13657">
      {/* 1. ВЕРХНИЙ БЛОК (HEADER) */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4 bg-white p-4 sm:p-5 rounded-2xl border border-slate-200 shadow-sm" data-id="element-13658">
        <div data-id="element-13659">
          <div className="flex items-center gap-3 mb-1" data-id="element-13660">
            <h2 className="text-xl sm:text-2xl font-bold text-slate-900" data-id="element-13661">
              Обзор
            </h2>
            <Badge variant="pro" className="flex items-center gap-1" data-id="element-13662">
              <Crown className="w-3 h-3" data-id="element-13663" /> PRO
            </Badge>
            <Badge variant="success" className="flex items-center gap-1" data-id="element-13664">
              <ShieldCheck className="w-3 h-3" data-id="element-13665" /> Проверен
            </Badge>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-13666">
            Добро пожаловать, Анна! Вот ваша сводка на сегодня.
          </p>
        </div>

        <div className="flex flex-wrap items-center gap-4 lg:gap-6 bg-slate-50 p-3 rounded-xl border border-slate-100 w-full lg:w-auto" data-id="element-13667">
          <div className="flex flex-col" data-id="element-13668">
            <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider mb-0.5" data-id="element-13669">
              Заполнение
            </span>
            <div className="flex items-center gap-2" data-id="element-13670">
              <div className="w-16 h-1.5 bg-slate-200 rounded-full overflow-hidden" data-id="element-13671">
                <div className="w-[75%] h-full bg-amber-500 rounded-full" data-id="element-13672" />
              </div>
              <span className="text-sm font-bold text-slate-900" data-id="element-13673">75%</span>
            </div>
          </div>
          <div className="w-px h-8 bg-slate-200 hidden sm:block" data-id="element-13674" />
          <div className="flex flex-col" data-id="element-13675">
            <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider mb-0.5" data-id="element-13676">
              Рейтинг
            </span>
            <div className="flex items-center gap-1" data-id="element-13677">
              <Star className="w-4 h-4 text-amber-400 fill-amber-400" data-id="element-13678" />
              <span className="text-sm font-bold text-slate-900" data-id="element-13679">4.9</span>
            </div>
          </div>
          <div className="w-px h-8 bg-slate-200 hidden sm:block" data-id="element-13680" />
          <div className="flex flex-col" data-id="element-13681">
            <span className="text-[10px] text-slate-500 uppercase font-bold tracking-wider mb-0.5" data-id="element-13682">
              Конверсия
            </span>
            <div className="flex items-center gap-1" data-id="element-13683">
              <Percent className="w-4 h-4 text-emerald-500" data-id="element-13684" />
              <span className="text-sm font-bold text-slate-900" data-id="element-13685">12.4%</span>
            </div>
          </div>
        </div>
      </div>

      {/* 1.1 ДИНАМИЧЕСКИЙ БЛОК ЗАПОЛНЕНИЯ ПРОФИЛЯ */}
      <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-2xl p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 shadow-sm" data-id="element-13686">
        <div className="flex items-start gap-3" data-id="element-13687">
          <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-13688">
            <AlertCircle className="w-5 h-5 text-amber-600" data-id="element-13689" />
          </div>
          <div data-id="element-13690">
            <h4 className="text-sm sm:text-base font-bold text-amber-900" data-id="element-13691">
              Профиль заполнен не полностью (вы теряете ~30% заказов)
            </h4>
            <div className="flex flex-wrap gap-2 mt-2" data-id="element-13692">
              <button onClick={() => setActiveTab('profile')} className="flex items-center gap-1.5 text-xs font-medium text-amber-800 bg-amber-200/50 px-3 py-1.5 rounded-lg hover:bg-amber-300/50 transition-colors" data-id="element-13693">
                <Video className="w-3.5 h-3.5" data-id="element-13694" /> Добавить видео-визитку
              </button>
              <button onClick={() => setActiveTab('reviews')} className="flex items-center gap-1.5 text-xs font-medium text-amber-800 bg-amber-200/50 px-3 py-1.5 rounded-lg hover:bg-amber-300/50 transition-colors" data-id="element-13695">
                <Star className="w-3.5 h-3.5" data-id="element-13696" /> Собрать еще 3 отзыва
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6" data-id="element-13697">
        {/* ЛЕВАЯ КОЛОНКА (Основной фокус) */}
        <div className="lg:col-span-8 flex flex-col gap-4 sm:gap-6 min-w-0" data-id="element-13698">
          {/* 1. ПРОБЛЕМЫ И РИСКИ (CRITICAL) */}
          <Card padding="md" className="border-rose-300 bg-rose-50/80 shadow-sm relative overflow-hidden" data-id="element-13699">
            <div className="absolute top-0 left-0 w-1 h-full bg-rose-500" data-id="element-13700" />
            <div className="flex items-center gap-2 mb-4" data-id="element-13701">
              <ShieldAlert className="w-6 h-6 text-rose-600" data-id="element-13702" />
              <h3 className="text-lg font-bold text-rose-900" data-id="element-13703">
                Требует срочного внимания
              </h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-13704">
              <div className="bg-white border border-rose-200 p-3 sm:p-4 rounded-xl flex flex-col xs:flex-row items-start xs:items-center justify-between shadow-sm gap-3 min-w-0 overflow-hidden" data-id="element-13705">
                <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-13706">
                  <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 font-bold text-lg shrink-0" data-id="element-13707">
                    2
                  </div>
                  <div className="min-w-0" data-id="element-13708">
                    <div className="text-sm font-bold text-slate-900 truncate" data-id="element-13709">
                      Сообщения без ответа
                    </div>
                    <div className="text-xs text-rose-600 flex items-center mt-0.5" data-id="element-13710">
                      <Clock className="w-3 h-3 mr-1 shrink-0" data-id="element-13711" /> более 24 часов
                    </div>
                  </div>
                </div>
                <Button variant="outline" size="sm" className="text-rose-600 border-rose-200 hover:bg-rose-50 shrink-0 w-full xs:w-auto" onClick={() => setActiveTab('chat')} data-id="element-13712">
                  Ответить
                </Button>
              </div>
              <div className="bg-white border border-rose-200 p-3 sm:p-4 rounded-xl flex flex-col xs:flex-row items-start xs:items-center justify-between shadow-sm gap-3 min-w-0 overflow-hidden" data-id="element-13713">
                <div className="flex items-center gap-3 min-w-0 flex-1" data-id="element-13714">
                  <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 font-bold text-lg shrink-0" data-id="element-13715">
                    1
                  </div>
                  <div className="min-w-0" data-id="element-13716">
                    <div className="text-sm font-bold text-slate-900 truncate" data-id="element-13717">
                      Просроченный заказ
                    </div>
                    <div className="text-xs text-rose-600 flex items-center mt-0.5" data-id="element-13718">
                      <AlertTriangle className="w-3 h-3 mr-1 shrink-0" data-id="element-13719" /> Риск
                      возврата
                    </div>
                  </div>
                </div>
                <Button variant="outline" size="sm" className="text-rose-600 border-rose-200 hover:bg-rose-50 shrink-0 w-full xs:w-auto" onClick={() => setActiveTab('orders')} data-id="element-13720">
                  Перейти
                </Button>
              </div>
            </div>
          </Card>

          {/* 2. НОВЫЕ ЗАКАЗЫ (Усиленный) */}
          <Card padding="md" className="border-amber-200 shadow-sm relative overflow-hidden" data-id="element-13721">
            <div className="absolute top-0 left-0 w-1 h-full bg-amber-400" data-id="element-13722" />
            <div className="flex justify-between items-center mb-4 pl-2" data-id="element-13723">
              <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-13724">
                <ShoppingBag className="w-5 h-5 text-amber-500" data-id="element-13725" /> Новые заказы
                <Badge variant="warning" className="ml-2" data-id="element-13726">
                  3
                </Badge>
              </h3>
              <button onClick={() => setActiveTab('orders')} className="text-sm text-indigo-600 font-medium hover:text-indigo-700 flex items-center" data-id="element-13727">
                Все заказы <ArrowRight className="w-4 h-4 ml-1" data-id="element-13728" />
              </button>
            </div>
            <div className="space-y-3" data-id="element-13729">
              {[{
              id: '1042',
              client: 'Мария В.',
              type: 'Натальная карта',
              price: '5 000 ₽',
              source: 'Реклама',
              timer: 'Осталось 1ч 15м',
              urgent: true,
              paid: true
            }, {
              id: '1041',
              client: 'Ольга П.',
              type: 'Детский гороскоп',
              price: '4 500 ₽',
              source: 'Поиск',
              timer: 'Осталось 8ч',
              urgent: false,
              paid: false
            }].map((o, i) => <div key={i} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl border border-slate-200 hover:border-amber-300 transition-all gap-4 bg-white" data-id="element-13730">
                  <div className="flex-1" data-id="element-13731">
                    <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 mb-1.5" data-id="element-13732">
                      <span className="text-xs font-mono text-slate-400" data-id="element-13733">
                        #{o.id}
                      </span>
                      <span className="text-sm font-bold text-slate-900" data-id="element-13734">
                        {o.client}
                      </span>
                      <Badge variant="neutral" size="sm" className="text-[10px]" data-id="element-13735">
                        {o.source}
                      </Badge>
                      {o.paid ? <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded flex items-center whitespace-nowrap" data-id="element-13736">
                          <CheckCircle2 className="w-3 h-3 mr-1 flex-shrink-0" data-id="element-13737" />
                          Оплачено
                        </span> : <span className="text-[10px] font-bold text-amber-600 bg-amber-50 px-1.5 py-0.5 rounded flex items-center whitespace-nowrap" data-id="element-13738">
                          <CreditCard className="w-3 h-3 mr-1 flex-shrink-0" data-id="element-13739" />
                          Ждет оплаты
                        </span>}
                    </div>
                    <div className="text-xs text-slate-600 flex flex-wrap items-center gap-3" data-id="element-13740">
                      <span className="font-medium text-slate-900" data-id="element-13741">
                        {o.type}
                      </span>
                      <span className="font-bold text-emerald-600" data-id="element-13742">
                        {o.price}
                      </span>
                      <span className={`flex items-center font-bold px-2 py-0.5 rounded ${o.urgent ? 'bg-rose-100 text-rose-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-13743">
                        <Clock className="w-3 h-3 mr-1" data-id="element-13744" /> {o.timer} на ответ
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-13745">
                    <Button variant="outline" size="md" className="flex-1 sm:flex-none text-slate-600" onClick={() => setActiveTab('chat')} data-id="element-13746">
                      Написать
                    </Button>
                    <Button variant="primary" size="md" className="flex-1 sm:flex-none bg-amber-500 hover:bg-amber-600 text-white border-none shadow-sm" onClick={() => showToast('Заказ взят в работу')} data-id="element-13747">
                      Взять в работу
                    </Button>
                  </div>
                </div>)}
            </div>
          </Card>

          {/* 3. БЛИЖАЙШИЕ КОНСУЛЬТАЦИИ */}
          <Card padding="md" className="border-slate-200 shadow-sm relative overflow-hidden" data-id="element-13748">
            <div className="absolute top-0 left-0 w-1 h-full bg-indigo-400" data-id="element-13749" />
            <div className="flex justify-between items-center mb-4 pl-2" data-id="element-13750">
              <h3 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-id="element-13751">
                <Video className="w-5 h-5 text-indigo-500" data-id="element-13752" /> Ближайшие
                консультации
              </h3>
              <button onClick={() => setActiveTab('consultations')} className="text-sm text-indigo-600 font-medium hover:text-indigo-700 flex items-center" data-id="element-13753">
                Календарь <ArrowRight className="w-4 h-4 ml-1" data-id="element-13754" />
              </button>
            </div>
            <div className="space-y-3" data-id="element-13755">
              {[{
              time: '14:00',
              client: 'Елена С.',
              type: 'Видео-разбор',
              status: 'Оплачено',
              timer: 'Через 45 мин',
              paid: true
            }, {
              time: '16:30',
              client: 'Дмитрий В.',
              type: 'Соляр',
              status: 'Не оплачено',
              timer: 'Через 3 ч',
              paid: false
            }].map((c, i) => <div key={i} className={`flex flex-col sm:flex-row sm:items-center justify-between p-4 rounded-xl border ${c.paid ? 'border-slate-200 hover:border-indigo-300' : 'border-amber-200 bg-amber-50/30'} transition-all gap-4`} data-id="element-13756">
                  <div className="flex items-center gap-4" data-id="element-13757">
                    <div className={`w-14 h-14 rounded-xl flex flex-col items-center justify-center flex-shrink-0 ${c.paid ? 'bg-indigo-50 text-indigo-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-13758">
                      <span className="text-sm font-bold" data-id="element-13759">
                        {c.time.split(':')[0]}
                      </span>
                      <span className="text-xs leading-none opacity-80" data-id="element-13760">
                        {c.time.split(':')[1]}
                      </span>
                    </div>
                    <div data-id="element-13761">
                      <div className="flex items-center gap-2 mb-1" data-id="element-13762">
                        <span className="text-sm font-bold text-slate-900" data-id="element-13763">
                          {c.client}
                        </span>
                        <Badge variant={c.paid ? 'success' : 'warning'} size="sm" data-id="element-13764">
                          {c.status}
                        </Badge>
                      </div>
                      <div className="text-xs text-slate-500 flex items-center gap-2" data-id="element-13765">
                        <span data-id="element-13766">{c.type}</span>
                        <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-13767" />
                        <span className="font-bold text-indigo-600 flex items-center" data-id="element-13768">
                          <Clock className="w-3 h-3 mr-1" data-id="element-13769" /> {c.timer}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 w-full sm:w-auto" data-id="element-13770">
                    {c.paid ? <Button variant="primary" size="md" className="flex-1 sm:flex-none bg-indigo-600 hover:bg-indigo-700" icon={<Play className="w-4 h-4" data-id="element-13772" />} onClick={() => showToast('Запуск видеозвонка...')} data-id="element-13771">
                        Начать
                      </Button> : <Button variant="outline" size="md" className="flex-1 sm:flex-none text-rose-600 border-rose-200 hover:bg-rose-50" onClick={() => showToast('Напоминание отправлено')} data-id="element-13773">
                        Напомнить об оплате
                      </Button>}
                  </div>
                </div>)}
            </div>
          </Card>

          {/* 4. ДОХОД И KPI (Перепакованный, плотный) */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-id="element-13774">
            <Card padding="sm" className="border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all cursor-pointer bg-emerald-50/30" onClick={() => setActiveTab('finances')} data-id="element-13775">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-13776">
                Выручка (Сегодня)
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-13777">
                12 400 ₽
              </div>
              <div className="text-[10px] font-bold text-emerald-600 flex items-center" data-id="element-13778">
                <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-13779" /> +24% к вчера
              </div>
            </Card>
            <Card padding="sm" className="border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all cursor-pointer" onClick={() => setActiveTab('finances')} data-id="element-13780">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-13781">
                Выручка (Месяц)
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-13782">
                348K ₽
              </div>
              <div className="text-[10px] font-bold text-emerald-600 flex items-center" data-id="element-13783">
                <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-13784" /> Прогноз: 420K ₽
              </div>
            </Card>
            <Card padding="sm" className="border-slate-200 hover:border-indigo-300 hover:shadow-md transition-all cursor-pointer" onClick={() => setActiveTab('finances')} data-id="element-13785">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-13786">
                Средний чек
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-13787">
                4 250 ₽
              </div>
              <div className="text-[10px] font-bold text-emerald-600 flex items-center" data-id="element-13788">
                <TrendingUp className="w-3 h-3 mr-0.5" data-id="element-13789" /> +5%
              </div>
            </Card>
            <Card padding="sm" className="border-slate-200 hover:border-blue-300 hover:shadow-md transition-all cursor-pointer" onClick={() => setActiveTab('orders')} data-id="element-13790">
              <div className="text-xs text-slate-500 font-medium mb-1 uppercase tracking-wider" data-id="element-13791">
                Заказы (Месяц)
              </div>
              <div className="text-xl sm:text-2xl font-bold text-slate-900 mb-1" data-id="element-13792">
                142
              </div>
              <div className="text-[10px] font-bold text-slate-500 flex items-center" data-id="element-13793">
                84 завершено
              </div>
            </Card>
          </div>

          {/* 5. РЕКОМЕНДАЦИИ РОСТА (ИИ) */}
          <Card padding="md" className="border-indigo-200 bg-gradient-to-br from-indigo-50/80 to-purple-50/80 shadow-sm" data-id="element-13794">
            <div className="flex items-center gap-2 mb-4" data-id="element-13795">
              <Lightbulb className="w-5 h-5 text-indigo-600" data-id="element-13796" />
              <h3 className="text-lg font-bold text-indigo-900" data-id="element-13797">
                Как увеличить доход
              </h3>
              <Badge variant="pro" className="ml-auto" data-id="element-13798">
                AI Ассистент
              </Badge>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-13799">
              <div className="bg-white p-4 rounded-xl border border-indigo-100 shadow-sm flex flex-col" data-id="element-13800">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-13801">
                  Высокий спрос
                </div>
                <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-13802">
                  Натальная карта продается отлично
                </div>
                <p className="text-xs text-slate-600 mb-4 flex-1" data-id="element-13803">
                  Спрос вырос на 15%. Вы можете безопасно поднять цену без
                  потери клиентов.
                </p>
                <Button variant="outline" size="sm" className="text-indigo-700 border-indigo-200 hover:bg-indigo-50 w-full" onClick={() => setActiveTab('services')} data-id="element-13804">
                  Поднять цену на 10%
                </Button>
              </div>
              <div className="bg-white p-4 rounded-xl border border-indigo-100 shadow-sm flex flex-col" data-id="element-13805">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-2" data-id="element-13806">
                  Точка роста
                </div>
                <div className="text-sm font-bold text-slate-900 mb-1" data-id="element-13807">
                  Детский гороскоп проседает
                </div>
                <p className="text-xs text-slate-600 mb-4 flex-1" data-id="element-13808">
                  0 продаж за неделю. Включите рекламу в каталоге, чтобы
                  получить первые заказы.
                </p>
                <Button variant="primary" size="sm" className="bg-indigo-600 hover:bg-indigo-700 w-full" onClick={() => setActiveTab('promotion')} data-id="element-13809">
                  Запустить рекламу
                </Button>
              </div>
            </div>
          </Card>
        </div>

        {/* ПРАВАЯ КОЛОНКА (Вторичная) */}
        <div className="lg:col-span-4 flex flex-col gap-4 sm:gap-6 min-w-0" data-id="element-13810">
          {/* БЫСТРЫЕ ДЕЙСТВИЯ (Крупные, важные) */}
          <div className="grid grid-cols-2 gap-3" data-id="element-13811">
            <button onClick={() => setActiveTab('services')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-indigo-300 hover:shadow-md transition-all group" data-id="element-13812">
              <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-13813">
                <Plus className="w-5 h-5 text-indigo-600" data-id="element-13814" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-13815">
                Создать
                <br data-id="element-13816" />
                услугу
              </span>
            </button>
            <button onClick={() => setActiveTab('marketplace')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-purple-300 hover:shadow-md transition-all group" data-id="element-13817">
              <div className="w-10 h-10 rounded-full bg-purple-50 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-13818">
                <Store className="w-5 h-5 text-purple-600" data-id="element-13819" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-13820">
                Добавить
                <br data-id="element-13821" />
                курс
              </span>
            </button>
            <button onClick={() => setActiveTab('promotion')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-amber-300 hover:shadow-md transition-all group" data-id="element-13822">
              <div className="w-10 h-10 rounded-full bg-amber-50 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-13823">
                <Zap className="w-5 h-5 text-amber-600" data-id="element-13824" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-13825">
                Включить
                <br data-id="element-13826" />
                рекламу
              </span>
            </button>
            <button onClick={() => setActiveTab('profile')} className="flex flex-col items-center justify-center p-4 rounded-xl border border-slate-200 bg-white hover:border-slate-400 hover:shadow-md transition-all group" data-id="element-13827">
              <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center mb-2 group-hover:scale-110 transition-transform" data-id="element-13828">
                <Settings className="w-5 h-5 text-slate-600" data-id="element-13829" />
              </div>
              <span className="text-sm font-bold text-slate-700 text-center" data-id="element-13830">
                Настроить
                <br data-id="element-13831" />
                профиль
              </span>
            </button>
          </div>

          {/* БЛОК РЕКЛАМЫ */}
          <Card padding="md" className="border-indigo-200 bg-indigo-50/50 shadow-sm" data-id="element-13832">
            <div className="flex justify-between items-start mb-4" data-id="element-13833">
              <div data-id="element-13834">
                <h3 className="text-base font-bold text-indigo-900 flex items-center gap-2" data-id="element-13835">
                  <Zap className="w-4 h-4 text-amber-500 fill-amber-500" data-id="element-13836" />{' '}
                  Реклама активна
                </h3>
                <p className="text-xs text-indigo-700 mt-0.5" data-id="element-13837">
                  Осталось 5 дней
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mb-4" data-id="element-13838">
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-13839">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-13840">
                  Показы
                </div>
                <div className="text-lg font-bold text-slate-900" data-id="element-13841">12.4K</div>
              </div>
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-13842">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-13843">
                  Клики (4.2%)
                </div>
                <div className="text-lg font-bold text-slate-900" data-id="element-13844">524</div>
              </div>
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-13845">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-13846">
                  Заявки
                </div>
                <div className="text-lg font-bold text-emerald-600" data-id="element-13847">18</div>
              </div>
              <div className="bg-white p-3 rounded-lg border border-indigo-100 shadow-sm" data-id="element-13848">
                <div className="text-[10px] text-slate-500 uppercase font-bold mb-1" data-id="element-13849">
                  Доход
                </div>
                <div className="text-lg font-bold text-emerald-600" data-id="element-13850">74K ₽</div>
              </div>
            </div>

            <div className="flex flex-col gap-2" data-id="element-13851">
              <Button variant="primary" size="md" fullWidth className="bg-indigo-600 hover:bg-indigo-700 shadow-sm" onClick={() => setActiveTab('promotion')} data-id="element-13852">
                Увеличить бюджет
              </Button>
            </div>
          </Card>

          {/* АКТИВНОСТЬ ПРОФИЛЯ (Воронка) */}
          <Card padding="md" className="border-slate-200 shadow-sm" data-id="element-13853">
            <h3 className="text-base font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-13854">
              <Activity className="w-4 h-4 text-blue-500" data-id="element-13855" /> Воронка профиля (7
              дней)
            </h3>
            <div className="space-y-4" data-id="element-13856">
              <div data-id="element-13857">
                <div className="flex justify-between text-sm mb-1" data-id="element-13858">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-13859">
                    <Eye className="w-3.5 h-3.5" data-id="element-13860" /> Просмотры
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13861">1,245</span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-13862">
                  <div className="w-full h-full bg-blue-400 rounded-full" data-id="element-13863" />
                </div>
              </div>
              <div data-id="element-13864">
                <div className="flex justify-between text-sm mb-1" data-id="element-13865">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-13866">
                    <MousePointerClick className="w-3.5 h-3.5" data-id="element-13867" /> Клики на
                    услуги
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13868">
                    312{' '}
                    <span className="text-xs text-slate-400 font-normal" data-id="element-13869">
                      (25%)
                    </span>
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-13870">
                  <div className="w-[25%] h-full bg-indigo-400 rounded-full" data-id="element-13871" />
                </div>
              </div>
              <div data-id="element-13872">
                <div className="flex justify-between text-sm mb-1" data-id="element-13873">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-13874">
                    <Heart className="w-3.5 h-3.5" data-id="element-13875" /> В избранное
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13876">
                    84{' '}
                    <span className="text-xs text-slate-400 font-normal" data-id="element-13877">
                      (6%)
                    </span>
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-13878">
                  <div className="w-[6%] h-full bg-rose-400 rounded-full" data-id="element-13879" />
                </div>
              </div>
              <div data-id="element-13880">
                <div className="flex justify-between text-sm mb-1" data-id="element-13881">
                  <span className="text-slate-600 flex items-center gap-1.5" data-id="element-13882">
                    <ShoppingBag className="w-3.5 h-3.5" data-id="element-13883" /> Переходы в заказ
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13884">
                    42{' '}
                    <span className="text-xs text-slate-400 font-normal" data-id="element-13885">
                      (3.3%)
                    </span>
                  </span>
                </div>
                <div className="w-full h-2 bg-slate-100 rounded-full overflow-hidden" data-id="element-13886">
                  <div className="w-[3%] h-full bg-emerald-400 rounded-full" data-id="element-13887" />
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}